export const getWeatherData = (name) => {
    let weatherrData;
    if (localStorage.getItem(name)) {
      weatherrData = JSON.parse(localStorage.getItem(name));
    }  
    return weatherrData;
};

export const getUserLocation = () => {
    var position = null;
    const weatherData = getWeatherData("offlineWeatherData");
    let data = {};
    let location = {};
    if (weatherData && weatherData.saved) {
      data = weatherData.saved;
      let coordinates = JSON.parse(data.coordinates);
      location = {
        coordinates: {
          lat: parseFloat(coordinates.lat),
          lng: parseFloat(coordinates.lng),
        },
        locationName: data.name + ', ' + data.locationName,
      };
      position = location;
    } else if (weatherData && weatherData.cookie) {
      data = weatherData.cookie;
      location = {
        coordinates: {
          lat:  data.Latitude,
          lng:  data.Longitude,
        },
        locationName: data.City + ', ' + data.State,
      };
      position = location;
    }
    return position;
  };